<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-bottom:15px;">Acknowledgement</h1>
<p style="text-align: center;">To all those folk, especially Frank and Gillian, who encouraged <br/>me to share my story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?e2476b4a